import { render, staticRenderFns } from "./CompanyNotifications.vue?vue&type=template&id=fab74cd2&"
import script from "./CompanyNotifications.vue?vue&type=script&lang=js&"
export * from "./CompanyNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports